import Button from 'atoms/Button';
import Icon from 'atoms/Icon';
import './ConsumerLanding.scss';
import LandingImage from 'images/landing-page.png';
import { Link } from 'react-router-dom';

function ConsumerLanding() {
  return (
    <div className="consumer-landing">
      <div className="flex-column">
        <div className="consumer-landing-nav">
        <Button to="https://provider.mypawcare.com" size="medium" variant="white" text="Provider portal" />
        </div>
        <div className="flex-row consumer-landing-content justify-between">
          <div className="flex-column consumer-landing-content__info">
            <Icon name="pawcare" className="logo" iconProps={{ variant: '#00B383' }} />
            <h1>
              Own a dog or a cat?
              {' '}
              <br />
              {' '}
              Find groomers near you.
            </h1>
            <p>Easily find and book appointments with nearby providers. Exclusively in Chicago.</p>
            <div className="flex-row mt-25 actions">
              {/* <Icon className="mr-15" name="apple-store" /> */}
              <Link to='https://play.google.com/store/apps/details?id=com.mypawcare'>
                <Icon name="google-play"/>
              </Link>
            </div>
          </div>
          <img src={LandingImage} alt="decorative" className="consumer-landing-content__image" />
        </div>
      </div>
    </div>
  );
}

export default ConsumerLanding;
